module.exports = __webpack_public_path__ + "img/ncb.aee45b94.png";